module.exports = __webpack_public_path__ + "static/img/1-_05.794a27f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/1-_05.png
// module id = nJw+
// module chunks = 0